import { Center, Spinner } from '@chakra-ui/react';

const CenteredSpinner = ({ isLoading }) => {
  return (
    <>
      {isLoading ? (
        <div style={{ position: 'relative' }}>
          <Center position='fixed' top='0' left='0' right='0' bottom='0' backgroundColor='rgba(0, 0, 0, 0.4)' zIndex='9999'>
            <Spinner size='xl' color='brand.500' emptyColor='gray.200' />
          </Center>
        </div>
      ) : null}
    </>
  );
};

export default CenteredSpinner;
